import $ from 'jquery';

/**
 * Clear form elements
 *
 * @type {DynamicInitFunction<HTMLElement>}
 */
export default ($collection) => {

	$collection.on('click', (e) => {
		const $trigger = $(e.currentTarget);
		const $form = $($trigger.data('clearForm'));

		// Clear only specific fields
		if ($form.is('input,select,textarea')) {
			clearFormElement($form);
		}
		// Clear the whole form
		else {
			$form.find('input,textarea,select').each((_, el) => {
				// @ts-ignore
				clearFormElement(el);
			});
		}
	});
};

/**
 * @param {HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement | JQuery<HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement>} element
 */
function clearFormElement(element) {

	const $el = $(element);
	element = $el[0];
	$el.trigger('clear');

	// Ignore some standard cases
	// @ts-ignore
	if (element.type === 'hidden' || element.disabled || element.readOnly) {
		return;
	}

	// @ts-ignore
	if (element.type === 'checkbox' || element.type === 'radio') {
		// @ts-ignore
		element.checked = false;
	}
	else {
		$el.val(null);
	}
	$el.triggerNative('change');
}